import { group } from 'd3'
import { selectAllalaSQL } from './load/alasql.js'

export const zenDb = {}

export function indexValuesDB () {
  const allStoredValues = selectAllalaSQL()

  zenDb.map = group(allStoredValues,
    d => d.accounting_organisation_id,
    d => d.currencyCode,
    d => d.accounting_chart_of_account_id,
    d => d.month
  )
}
